import styled, { createGlobalStyle } from 'styled-components/macro'
import vazirmatn from '../assets/fonts/Vazirmatn/Vazirmatn-Regular.woff2'
import theme from './theme'

export const BaseStyles = createGlobalStyle`
  @font-face {
    font-family: vazirmatn;
    src: url(${vazirmatn});
  }

  body {
    margin: 0;
    padding: 0;
    font-size: ${theme.fontSize.text};
    direction: rtl;
    background-color: ${theme.colors.gray[5]};
    color: #444;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
    overscroll-behavior-x: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
  }

  html, body {
    height: 100%;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

  h1 {
    font-size: ${theme.fontSize.topHeader}
  }
  h2 {
    font-size: ${theme.fontSize.header}
  }

  * {
    box-sizing: border-box;
    font-family: vazirmatn, sans-serif;
    line-height: ${theme.lineHeight};
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  max-width: ${theme.maxWidth};
  margin: auto;
`

export const Main = styled.main`
  min-height: ${window.innerHeight}px;
  width: 100%;
  max-width: ${props => props.theme.maxWidth};
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: #fff;
`

export const HomeBodyPlanets = styled.div`
  border-radius: ${theme.borderRadius};
  background-color: ${theme.colors.gray[4]};
  margin-bottom: ${theme.margin};
  padding: ${theme.padding};
`